
            const data = {"name":"flag","data":{"width":"16","height":"16","viewBox":"0 0 16 16","data":"<path pid=\"0\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M4.5 2a.5.5 0 0 0-.5.5v11a.5.5 0 0 0 1 0V8h6.793a.5.5 0 0 0 .353-.854L10 5l2.146-2.146A.5.5 0 0 0 11.793 2H4.5ZM5 3v4h5.586l-2-2 2-2H5Z\" _fill=\"#D32F2F\"/>","originalColors":[{"type":"fill","color":"#D32F2F"}],"stopColors":[]}}
        
                    module.exports = data
                    